'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BiddingInfoRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BiddingInfoRemote = exports.BiddingInfoRemote = {
    fetchBidderBidding: function fetchBidderBidding(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>bidder/bidding/all' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchCatalogBidding: function fetchCatalogBidding(_ref2) {
        var authToken = _ref2.authToken,
            catalogId = _ref2.catalogId,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({
                authToken: authToken,
                deployment: deployment,
                path: '<ITEM-API>spa/small/catalog/' + catalogId + '/bidding'
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchItemBidding: function fetchItemBidding(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            itemId = _ref3.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/item/' + itemId + '/bidding' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/biddingInfo.js
// module id = bigW
// module chunks = 60